module.exports = __webpack_public_path__ + "assets/images/icon-tile-party.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-tile-party.svg
// module id = 25
// module chunks = 0